




















import { Component, Vue, Prop } from 'vue-property-decorator'
import BoxTitle from './BoxTitle.vue'

@Component({
  components: {
    BoxTitle
  }
})

export default class AdvAbility extends Vue {
  @Prop()
  abilities!: object

  get isPrivate () {
    return this.$store.getters['isPrivate']
  }
}

